
// TODO - Type 'any' needs to be fixed.
export const setStartReducer = (state:any, action:any) => {
    state.startDate = action.payload
  }